module.exports = __webpack_public_path__ + "img/bjtitle.6e06bb08.png";